
































































































































































































































































import Vue from 'vue';
import { getContentArea } from '@/contentful';
import { FullscreenWrapper } from '@/components/fullscreen-wrapper-components';
import { CloseFullscreenWrapper } from '@/mixins';
import { EventBus } from '@/event-bus';
import { ExtendMixins } from '@/services';
import { ConstructPhoneNumber } from '@/helpers';
import {
  Address, Claim,
  MemberPersonalInformationResponseModel,
  MemberProvidersResponseModel,
  UserModel,
} from '@/@types/member';

interface Data {
  showSuccessMessage: boolean;
  hasPrinted: boolean;
  // TODO typings
  claim: any;
  // TODO typings
  account: any;
  serviceType: string;
  accountHolderSignatureText: string;
  previousTitle: string;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
).extend({
  name: 'PrintClaim',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      showSuccessMessage: false,
      hasPrinted: false,
      claim: this.params.claimInfo,
      account: this.params.account,
      serviceType: this.params.serviceType,
      accountHolderSignatureText: '',
      previousTitle: document.title,
    };
  },
  computed: {
    user(): UserModel {
      return this.$store.getters.user;
    },
    personalInformation(): MemberPersonalInformationResponseModel {
      return this.$store.getters.personalInformation;
    },
    address(): Address {
      return this.personalInformation.address;
    },
    primaryPhone(): string {
      return ConstructPhoneNumber(this.personalInformation.primaryPhone);
    },
    providers(): MemberProvidersResponseModel[] {
      return this.$store.getters.providers;
    },
    selectedProvider(): MemberProvidersResponseModel {
      return this.providers.find((provider) => {
        return provider.providerId.toString() === this.claim.payTo.value.toString();
      });
    },
    isDCAPAccount(): boolean {
      return this.account.productType === 'DCAP';
    },
    isPRAAccount(): boolean {
      return this.account.productType === 'PRA';
    },
    pageTitle(): string {
      if (this.isDCAPAccount) {
        return this.$options.filters.t('print-claim_page-title_dcap');
      } else if (this.isPRAAccount) {
        return this.$options.filters.t('print-claim_page-title_pra');
      } else {
        return this.$options.filters.varReplace(
          this.$options.filters.t('print-claim_page-title_other'),
          { accountType: this.account.productType },
        );
      }
    },
    pageDescription(): string {
      if (this.isDCAPAccount) {
        return this.$options.filters.t('print-claim_page-description_dcap');
      } else if (this.isPRAAccount) {
        return this.$options.filters.t('print-claim_page-description_pra');
      } else {
        return this.$options.filters.t('print-claim_page-description_other');
      }
    },
  },
  beforeMount() {
    let contentAreaSlug;
    if (this.isDCAPAccount) {
      contentAreaSlug = 'account-holder-signature-text-dcap';
    } else if (this.isPRAAccount) {
      contentAreaSlug = 'account-holder-signature-text-pra';
    } else {
      contentAreaSlug = 'account-holder-signature-text-fsa-hra-veba-or-hia';
    }
    getContentArea(contentAreaSlug).then((data) => {
      if (data) {
        this.accountHolderSignatureText = data.fields.content;
      }
    });

    //      Update document title
    document.title = `${this.user.firstName} ${this.user.lastName} (${
      this.user.selectAccountId
    })`;
  },
  beforeDestroy() {
    //      Set document title back to previous one
    document.title = this.previousTitle;
  },
  methods: {
    printClaim(): void {
      this.hasPrinted = true;
      window.print();
    },
    next(): void {
      EventBus.$emit('closePrintClaimScreen');
      this.closeFullscreenWrapper();
    },
  },
  components: {
    FullscreenWrapper,
  },
});
